import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { issueNavigatorProjectClassicCustomEmbedRoute } from '@jira/router-routes__issue-navigator-routes/src/issueNavigatorProjectClassicCustomEmbedRoute.tsx';
import { EmbedIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/embed-app.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getCommonProjectResources } from './common/getCommonProjectResources.tsx';
import { issueNavigatorEmbedPageEntryPoint } from './ui/index.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import { ListRedirect } from './ui/list-redirect/ListRedirect.tsx';

/**
 * Classic Project Issue Navigator Embed Route Entry
 * Handles Classic projects, also known as company-managed projects.
 */
export const issueNavigatorProjectClassicCustomEmbedRouteEntry: Route = createEntry(
	issueNavigatorProjectClassicCustomEmbedRoute,
	() => ({
		group: 'issue-navigator',

		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},

		skeleton: EmbedIssueNavigatorSkeleton,
		resources: [...getCommonProjectResources()],
		layout: chromelessLayout,
		isHydrateRootEnabled: true,
		isStreamingEnabled: fg('jfp-magma-ssr-streaming-enable-nin'),

		// eslint-disable-next-line no-restricted-syntax
		component: fg('jira_list_nin_merge') ? ListRedirect : undefined,
		entryPoint: () => (fg('jira_list_nin_merge') ? undefined : issueNavigatorEmbedPageEntryPoint),
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
